module.exports = __webpack_public_path__ + "static/media/landing-1.3a45315b.jpg";